"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordShaper = WordShaper;
const isArabic_1 = require("./isArabic");
const reference_1 = require("./reference");
const CharShaper_1 = require("./CharShaper");
const unicode_ligatures_1 = require("./unicode-ligatures");
function WordShaper(word) {
    let state = 'initial';
    let output = '';
    for (let w = 0; w < word.length; w++) {
        let nextLetter = ' ';
        for (let nxw = w + 1; nxw < word.length; nxw++) {
            if (!(0, isArabic_1.isArabic)(word[nxw])) {
                break;
            }
            if (reference_1.tashkeel.indexOf(word[nxw]) === -1) {
                nextLetter = word[nxw];
                break;
            }
        }
        if (!(0, isArabic_1.isArabic)(word[w]) || (0, isArabic_1.isMath)(word[w])) {
            // space or other non-Arabic
            output += word[w];
            state = 'initial';
        }
        else if (reference_1.tashkeel.indexOf(word[w]) > -1) {
            // tashkeel - add without changing state
            output += word[w];
        }
        else if ((nextLetter === ' ') // last Arabic letter in this word
            || (reference_1.lineBreakers.indexOf(word[w]) > -1)) { // the current letter is known to break lines
            output += (0, CharShaper_1.CharShaper)(word[w], state === 'initial' ? 'isolated' : 'final');
            state = 'initial';
        }
        else if (reference_1.lams.indexOf(word[w]) > -1 && reference_1.alefs.indexOf(nextLetter) > -1) {
            // LA letters - advance an additional letter after this
            output += unicode_ligatures_1.default[word[w] + nextLetter][(state === 'initial' ? 'isolated' : 'final')];
            while (word[w] !== nextLetter) {
                w++;
            }
            state = 'initial';
        }
        else {
            output += (0, CharShaper_1.CharShaper)(word[w], state);
            state = 'medial';
        }
    }
    return output;
}
